import { ApiResult, BaseApi, BaseApiV2, QueryWrapper } from "@newview/infrastructure";

export interface Button {
    /**
     * 名称，唯一标识
     */
    name: string;
    /**
     * 文本
     */
    text?: string;
    /**
     * 图标
     */
    iconClass?: string;
    /** 样式 */
    className?: string;
    /**
     * 点击方法
     */
    onclick?: Function;
    /**
     * 按钮类型
     */
    type?: string;
    /**
     * 是否显示
     */
    isShow?: Function | boolean;
    /**
     * 是否禁用
     */
    isEnable?: Function;
}

/**
 * 时间参数
 */
export interface DatePickerProp {
    format?: string,
    type?: "date" | "daterange" | "datetime" | "datetimerange" | "year" | "month"
}

/**
 * 数字参数
 */
export interface InputNumberProp {
    min?: number
}

export interface SelectOptionProp {
    value: any,
    text: any
}

/**
 * 下拉框配置
 */
export interface SelectProp {
    /**
     * 
     */
    data?: SelectOptionProp[],
    getData?: Function,
    filterable?: boolean,
    allowCreate?: boolean,
    multiple?: boolean,
    remoteMethod?: Function,
    remote?: boolean
}

/**
 * 自动完成组件参数
 */
export interface AutoCompleteProp {
    data?: any[],
    filterMethod?: Function
}
/**
 * 表头筛选配置参数
 */ 
export interface headerFilter {
    type?:"input" | "select" | "date" | "year" | "month" | "datetime" | "daterange" | "inputnumber",
    options?:SelectOptionProp[],
    multiple?: boolean,
    value?:any
}


/**
 * 列参数
 */
export interface Column {

    // iview Table column 对应属性

    /**
     * 列头显示文字	
     */
    title?: string;
    /**
     * 对应列内容的字段名	
     */
    key?: string;
    /**
     * 列宽
     */
    width?: number;
    /**
     * 最小列宽
     */
    minWidth?: number;
    /**
     * 最大列宽
     */
    maxWidth?: number;
    /**
     * 对齐方式，可选值为 left 左对齐、right 右对齐和 center 居中对齐
     */
    align?: string;
    /**
     * 列的样式名称
     */
    className?: string;
    /**
     * 列是否固定在左侧或者右侧，可选值为 left 左侧和 right 右侧
     */
    fixed?: string;
    /**
     * 开启后，文本将不换行，超出部分显示为省略号
     */
    ellipsis?: boolean;
    /**
     * 开启后，文本将不换行，超出部分显示为省略号，并用 Tooltip 组件显示完整内容
     */
    tooltip?: boolean;
    /**
     * type 为 index 时可用，自定义序号
     */
    indexMethod?: Function;
    /**
     * 对应列是否可以排序，如果设置为 custom，则代表用户希望远程排序，需要监听 Table 的 on-sort-change 事件
     */
    sortable?: boolean | 'custom';
    /**
     * 自定义排序使用的方法，接收三个参数 a 、 b 和 type，当设置 sortable: true 时有效。type 值为 asc 和 desc
     */
    sortMethod?: Function;
    /**
     * 设置初始化排序。值为 asc 和 desc
     */
    sortType?: string;
    /**
     * 过滤数据的选项，格式为数组，数组中每项包含 label 和 value 属性，使用过滤，必须同时配置 filterMethod
     */
    filters?: Array<any>;
    /**
     * 数据过滤使用的方法，如果是多选的筛选项，对每一条数据会执行多次，任意一次返回 true 就会显示
     */
    filterMethod?: Function;
    /**
     * 数据过滤的选项是否多选
     */
    filterMultiple?: boolean;
    /**
     * 在初始化时使用过滤，数组，值为需要过滤的 value 集合
     */
    filteredValue?: Array<any>;
    /**
     * 使用远程过滤
     */
    filterRemote?: Function;
    /**
     * 表头分组
     */
    children?: Array<any>;
    /**
     * 该列是否允许拖拽调整宽度，需开启 border 属性，且设置 width
     */
    resizable?: boolean;
    /**
     * 指定该列为显示展开/收起图标，树形数据时使用
     */
    tree?: boolean;
    /**
     * 使用 slot 自定义列时，列的渲染模式。可选值为 block、inline、inline-block，当使用树形数据时，建议使用 inline 或 inline-block
     */
    display?: string;
    slot?: string;

    // 修改属性
    render?: Function;
    /**
     * 渲染编辑模式
     */
    renderEditMode?: Function;
    /**
     * 渲染默认模式
     */
    renderViewMode?: Function;
    /**
     * 渲染头
     */
    renderHeader?: Function;

    // 扩展属性

    /**
     * 行编号
     */
    isShowOrderNumber?: boolean;

    /**
     * 全选行
     */
    isChkAll?: boolean;

    /**
     * 列类型 ch、ed、select、date、auto
     */
    colType?: "ch" | "ed" | "auto" | "num" | "select" | "date" | "ro" | "datetime" | "month" | "mobileNo" | "idcardNo" | "money";

    /**
     * ch 为编辑行
     */
    chEdit?: boolean,

    /**
     * 行按钮
     */
    rowButtons?: Button[];

    /**
     * 渲染函数
     */
    format?: Function;

    /**
     * 值改变事件
     */
    change?: Function;

    /**
     * 校验值
     */
    validator?: Function | string;

    /**
     * 日期类型参数
     */
    datePicker?: DatePickerProp;

    /**
     * 数字类型参数
     */
    inputNumberProp?: InputNumberProp

    /**
     * 下拉框参数
     */
    selectProp?: SelectProp;

    /**
     * 自动完成组件参数
     */
    autoCompleteProp?: AutoCompleteProp;

    /**
     * 默认值
     */
    defaultValue?: any;

    /**
     * 是否能编辑
     */
    isCanEdit?: Function;
    
    /**
     * 表头筛选配置
     */
    filter?:headerFilter
}



/**
 * 数据加载参数
 */
export interface LoadDataOptions {
    filter?: string;
    page?: number;
    pageSize?: number;
    sort?: string;
    /**
     * 是否分页
     */
    isPagination?: boolean;
    queryWrapper?: QueryWrapper;
    success: (datas: any) => void;
}

/**
 * 基本配置
 */
export interface Setting {
    /**
     * 按钮权限控制参数
     */
    operates?: string;
    /**
     * 表格类型('view'只读，'edit'行内编辑)
     */
    mode?: "view" | "edit";
    /**
     * 表格高度
     */
    height?: number;
    /**
     * 表格最大高度
     */
    maxHeight?: number;
    /**
     * 是否分页
     */
    isPagination?: boolean;
    /**
     * 是否为Tree
     */
    isTree?: boolean;
    /**
     * 是否显示孩子节点
     */
    isShowChildren?: boolean;
    /**
     * 行Key
     */
    rowKey?: string;
    /**
     * 每页大小
     */
    pageSize?: number;
    /**
     * 高亮选中行
     */
    isHighlightSelectRow?: boolean;
    /**
     * 搜索条件配置参数
     */
    searchSetting?: any;
    /**
     * 显示合计
     */
    showSummary?: boolean;
    /**
     * 合计方法
     */
    summaryMethod?: Function;
    /**
     * 删除提示语Key
     */
    delMsgKey?: string;
    /**
     * 开始时编辑
     */
    startEdit?: boolean;
}

/**
 * 事件
 */
export interface Event {
    /**
     * 开启 highlight-row 后有效，当表格的当前行发生变化的时候会触发
     */
    currentChange?: (currentRow, oldCurrentRow) => void;
    /**
     * 在多选模式下有效，选中某一项时触发
     */
    select?: (selection, row) => void;
    /**
     * 在多选模式下有效，取消选中某一项时触发
     */
    selectCancel?: (selection, row) => void;
    /**
     * 在多选模式下有效，点击全选时触发
     */
    selectAll?: (selection) => void;
    /**
     * 在多选模式下有效，点击取消全选时触发
     */
    selectAllCancel?: (selection) => void;
    /**
     * 在多选模式下有效，只要选中项发生变化时就会触发
     */
    selectionChange?: (selection) => void;
    /**
     * 排序时有效，当点击排序时触发
     */
    sortChange?: (column, key, order) => void;
    /**
     * 筛选时有效，筛选条件发生变化时触发
     */
    filterChange?: (colData) => void;
    /**
     * 	单击某一行时触发
     */
    rowClick?: (rowData, index) => void;
    /**
     * 双击某一行时触发
     */
    rowDblclick?: (rowData, index) => void;
    /**
     * 点击单元格时触发
     */
    cellClick?: (row, column, data, event) => void;
    /**
     * 展开或收起某一行时触发
     */
    expand?: (row, status) => void;
    /**
     * 拖拽排序松开时触发，返回置换的两行数据索引
     */
    dragDrop?: (index1, index2) => void;
    /**
     * 拖拽调整列宽时触发
     */
    columnWidthResize?: (newWidth, oldWidth, column, event) => void;
    /**
     * 当前行点击右键时触发
     */
    contextmenu?: (row, event, position) => void;
    /**
     * 展开或收起子数据时触发
     */
    expandTree?: (rowKey, status) => void;

    /**
     * 保存前事件
     */
    event_saveBefore?: (datas: any[]) => boolean;
    /**
     * 保存后事件
     */
    event_saveAfter?: (datas: any[], result: any) => void;

    /**
     * 删除前事件
     */
    event_deleteBefore?: (id: number, row: any) => boolean;

    /**
     * 删除后事件
     */
    event_deleteAfter?: (id: number, apiResult: ApiResult, row: any) => void;

    /**
     * 查询事件
     */
    event_search?: (datas: any) => void;
}

/**
 * Grid 参数配置
 */
export interface GridOption {

    /**
     * 基本属性
     */
    setting?: Setting;

    /**
     * 事件
     */
    event?: Event;

    /**
     * 工具栏按钮
     */
    toolbars?: Button[];

    /**
     * 列参数
     */
    columns?: Column[];

    /**
     * api接口对应类
     */
    api?: BaseApi | BaseApiV2;

}

export enum ValueRule {
    /**
     * yyyy-MM-dd HH:mm:ss
     */
    datetime = '$datetime',
    /**
     * yyyy-MM-dd
     */
    date = '$date',
    /**
     * HH:mm:ss
     */
    time = '$time',
    /**
     * 全球唯一标识
     */
    guid = '$guid'
}

export interface GloablValue {

    key: string,
    value: ValueRule | string,
    isOnlyAddSetValue: boolean

}